import { useTranslate } from '@tolgee/react';
import { FV } from './share';
import { Tabs } from 'antd';
import { useState } from 'react';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import FormField from 'components/FormField';
import ExecuteContextsFieldV2 from 'views/Aide/Scenario/PolicyForm/ExecuteContextsFieldV2';
import { Container } from 'views/Aide/Scenario/PolicyForm/BilingualExecuteContextField';
import { ExtraTabs } from 'views/Aide/Scenario/PolicyForm/TranslateTool';
import { DescendantExecuteContext, getSlateExecuteContext } from 'views/Aide/Scenario/PolicyForm';
import { platformExecuteContentLimitLengthMap } from 'services/config/platform';
import { getSegmentsLength } from 'components/TemplateEditor/Editor';

const randomCountLimit = 10;

function ReplyContent({
  platform,
  region,
  editable = true,
}: {
  platform?: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  editable?: boolean;
}) {
  const { t } = useTranslate();

  const [activeIndex, setActiveIndex] = useState(0);

  const appendKey = '@append';

  return (
    <FormField<FV['replyContent']>
      name="replyContent"
      validate={(value) => {
        if (value.length === 0) {
          return t('refundSetting.请输入回复内容');
        }

        const { MERCADO, ...otherLimitLengthMap } = platformExecuteContentLimitLengthMap;

        const contentLimit = platform
          ? platformExecuteContentLimitLengthMap[platform]
          : Math.min(...Object.values(otherLimitLengthMap));

        for (let index = 0; index < value.length; index++) {
          const { content } = value[index];

          const hasText = content.some((v) => v.type === 'paragraph');

          if (hasText) {
            const contentLength = getSegmentsLength(content, 'text');

            if (contentLength === 0) {
              return `${t('aide.回复内容index', { index: index + 1 })}: ${t(
                'refundSetting.请输入回复内容',
              )}`;
            } else if (contentLength > contentLimit) {
              return `${t('aide.回复内容index', { index: index + 1 })}: ${t(
                'refundSetting.回复内容不可超出x字',
                { x: contentLimit },
              )}`;
            }
          } else if (getSegmentsLength(content, 'image') === 0) {
            return `${t('aide.回复内容index', { index: index + 1 })}: ${t(
              'refundSetting.请输入回复内容',
            )}`;
          }
        }
      }}
    >
      {({ field: { value: list, onChange: onListChange } }) => {
        return (
          <Tabs
            type="card"
            activeKey={`${activeIndex}`}
            onChange={(key) => {
              if (key === appendKey) {
                onListChange([
                  ...list,
                  getSlateExecuteContext({
                    content: '',
                    translatedContent: '',
                  }),
                ]);
                setActiveIndex(list.length);
              } else {
                setActiveIndex(parseInt(key, 10));
              }
            }}
          >
            {list.map((value, index) => {
              const onChange = (value: DescendantExecuteContext) => {
                onListChange([...list.slice(0, index), value, ...list.slice(index + 1)]);
              };

              return (
                <Tabs.TabPane
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${index}`}
                  tab={
                    <div>
                      {t('aide.回复内容index', { index: index + 1 })}
                      {editable && list.length > 1 && (
                        <CloseOutlined
                          style={{ margin: '0 0 0 12px' }}
                          onClick={(e) => {
                            e.stopPropagation();

                            if (activeIndex >= index) {
                              setActiveIndex(0);
                            }

                            onListChange([...list.slice(0, index), ...list.slice(index + 1)]);
                          }}
                        />
                      )}
                    </div>
                  }
                >
                  <Container style={editable ? undefined : { cursor: 'not-allowed' }}>
                    <div style={editable ? undefined : { pointerEvents: 'none' }}>
                      <ExecuteContextsFieldV2
                        isQa
                        isReply
                        scenarioType="NIGHT_WATCH"
                        platform={platform}
                        region={region}
                        msgTypes={['text', 'image']}
                        value={value}
                        onChange={onChange}
                        error=""
                      />
                    </div>
                    <span>
                      <ExtraTabs
                        platform={platform}
                        region={region}
                        concepts={[]}
                        allowDividing
                        value={value}
                        onChange={onChange}
                        supportTranslate={editable}
                      />
                    </span>
                  </Container>
                </Tabs.TabPane>
              );
            })}
            {editable && list.length < randomCountLimit && (
              <Tabs.TabPane
                key={appendKey}
                tab={
                  <div>
                    <PlusOutlined />
                    <span>{t('aide.新增回复内容')}</span>
                  </div>
                }
              />
            )}
          </Tabs>
        );
      }}
    </FormField>
  );
}

export default ReplyContent;
